import React from "react";
import DashboardLayout from "../components/DashboardLayout";

function WorkPlans() {
  return (
    <DashboardLayout headerTitle="WorkPlans">
      <div className="mt-[20px] text-center">Page Contents</div>
    </DashboardLayout>
  );
}

export default WorkPlans;
